import React, { useState, Fragment } from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";

// const data = [
//   {
//     title:
//       "ถ้าใช้บริการโรงพยาบาลเอกชนใกล้ๆ ที่ไหนมีส่วนลดให้กับบุคลากร และ นักศึกษาบ้างคะ",
//     content: "Lorem ipsum dolor sit amet, consectetur ",
//   },
//   {
//     title: "การมาใช้บริการพบแพทย์ที่ห้องพยาบาล ต้องทำอย่างไรบ้างครับ",
//     content:
//       "Nunc maximus, magna at ultricies elementum, risus turpis vulputate quam.",
//   },
//   {
//     title:
//       "สวัสดีค่ะหนูเป็น นศ.ที่มจธ.อยากสอบถามว่า หมอด้านจิตแพทย์จะเข้ามา ที่ห้องพยาบาลวันไหนบ้างคะ ",
//     content:
//       "Curabitur laoreet, mauris vel blandit fringilla, leo elit rhoncus nunc",
//   },
// ];

export default function FAQ(props) {
  const [open, setOpen] = useState(0);

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };

  const customAnimation = {
    mount: { scale: 1 },
    unmount: { scale: 0.9 },
  };

  return (
    <div className="border-[1px] rounded-[12px] py-[14px] px-[20px] border-lightGray2">
      <Fragment>
        {props.data &&
          props.data.map((item, i) => (
            <Accordion key={i} open={open === i + 1} animate={customAnimation}>
              <AccordionHeader
                onClick={() => handleOpen(i + 1)}
                className="text-[18px] xl:text-[20px] font-medium text-black text-left ibm-plex-san faq-title"
              >
                {props.lang === "th"
                  ? item.question.detail_TH
                  : item.question.detail_EN}
              </AccordionHeader>
              <AccordionBody className="text-left ibm-plex-san text-[14px] xl:text-[18px] faq-body font-medium">
                {props.lang === "th"
                  ? item.answer.detail_TH
                  : item.answer.detail_EN}
              </AccordionBody>
            </Accordion>
          ))}
      </Fragment>
    </div>
  );
}
